import {ApplicationRef, Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {concat, interval} from 'rxjs';
import {first, take} from 'rxjs/operators';
import {ToastService} from '@app/service/util/toast.service';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  isBrowser: boolean;
  constructor(appRef: ApplicationRef, updates: SwUpdate, private toast: ToastService,
              @Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (!updates.isEnabled || !this.isBrowser) {
      return;
    }
    // Allow the app to stabilize first, before starting polling for updates with `interval()`.
    const appIsStable = appRef.isStable.pipe(first(isStable => isStable === true));
    const everyTenMinutes = interval(30 * 60000); // 1 minute == 60000ms -> 30minutes
    const everySixHoursOnceAppIsStable$ = concat(appIsStable, everyTenMinutes);

    everySixHoursOnceAppIsStable$.subscribe(() => updates.checkForUpdate());
    updates.available.subscribe(() => {
      this.toast.info('There is a new version available', 'Click to refresh', 0)
        .onClick
        .pipe(take(1))
        .subscribe(() => {
          updates.activateUpdate().then(() => window.location.reload());
        });
    });
  }
}
